// import React, { useState, useEffect } from 'react';
// import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
// import Login from './components/auth_page/Login';
// import Dashboard from './components/pages/Dashboard';
// import routes from './routes';
// import { useNavigate } from 'react-router-dom';
// import { getUserData } from './components/constants';
// import HomePage from './inTouchPages/homePage';
// import LandingPage from './inTouchPages/landingPage';
// import AppRoutes from './inTouchPages/Routes';
// import ProtectedRoute from './components/protectedRoute';
// import DesktopLayout from './components/desktopLayout';


// const App = () => {

//   const isAuthenticated = localStorage.getItem('token');
//   const navigate = useNavigate();
//   // console.log(getUserData());
//   const renderRoutes = (routes) =>
//     routes.map((route) => {
//       if (route.children) {
//         return (
//           <Route key={route.key} path={route.path} element={""}>
//             {renderRoutes(route.children)}
//           </Route>
//         );
//       }
//       return (
//         <Route
//           key={route.key}
//           path={route.path}
//           element={route.component ? <route.component /> : <div>{route.label} Page</div>}
//         />
//       );
//     });

//   return (

//     <Routes>

//       {!isAuthenticated ? (
//         <Route path="*" element={<Navigate to="/login" />} />
//       ) : (
//         <Route path="/" element={
//           // <DesktopLayout>
//             <ProtectedRoute>
//               <Dashboard />
//             </ProtectedRoute>
//           // </DesktopLayout>
//         }>
//           {renderRoutes(routes)}
//         </Route>
//       )}

//       <Route path="/login" element={isAuthenticated ? <Navigate to="/" replace /> : <Login />} />
//       <Route path="/in-touch" element={<HomePage />}>
//         {/* Nested route for LandingPage inside PageContent */}
//         <Route index element={<LandingPage />} /> {/* The index route for this path */}
//         <Route path="*" element={<AppRoutes />} />
//       </Route>
//     </Routes>

//   );

// };

// export default App;

// import { AdminAuthProvider } from './admin/AuthContext';
// import AdminLogin from './admin/AdminLogin';

// const App = () => {
//   const isAuthenticated = localStorage.getItem('token');
//   const navigate = useNavigate();
//   // console.log(getUserData());
//   const renderRoutes = (routes) =>
//     routes.map((route) => {
//       if (route.children) {
//         return (
//           <Route key={route.key} path={route.path} element={""}>
//             {renderRoutes(route.children)}
//           </Route>
//         );
//       }
//       return (
//         <Route
//           key={route.key}
//           path={route.path}
//           element={route.component ? <route.component /> : <div>{route.label} Page</div>}
//         />
//       );
//     });

//   return (
//     <AdminAuthProvider>
//       <Routes>
//         {!isAuthenticated ? (
//           <Route path="*" element={<Navigate to="/login" />} />
//         ) : (
//           <Route path="/" element={
//             <ProtectedRoute>
//               <Dashboard />
//             </ProtectedRoute>
//           }>
//             {renderRoutes(routes)}
//           </Route>
//         )}

//         <Route path="/login" element={isAuthenticated ? <Navigate to="/" replace /> : <Login />} />
//         <Route path="/admin/login" element={<AdminLogin />} />
//         <Route path="/in-touch" element={<HomePage />}>
//           <Route index element={<LandingPage />} />
//           <Route path="*" element={<AppRoutes />} />
//         </Route>
//       </Routes>
//     </AdminAuthProvider>
//   );
// };

// export default App;

// src/App.js
import React from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';

// ==== Normal User Imports ====
import Login from './components/auth_page/Login';
import Dashboard from './components/pages/Dashboard';
import routes from './routes';
import ProtectedRoute from './components/protectedRoute';
import HomePage from './inTouchPages/homePage';
import LandingPage from './inTouchPages/landingPage';
import AppRoutes from './inTouchPages/Routes';

// ==== Admin Imports ====
import { AdminAuthProvider } from './admin/AuthContext';
import AdminLogin from './admin/AdminLogin';
import AdminRoutes from './admin/AdminRoutes';
import { useLocation } from 'react-router-dom';

const App = () => {
  const isAuthenticated = localStorage.getItem('token'); // normal user token
  const navigate = useNavigate();
  const location = useLocation();

  // Recursively render nested user routes
  const renderRoutes = (routes) =>
    routes.map((route) => {
      if (route.children) {
        return route.children.map((child) => (
          <Route
            key={child.key}
            path={child.path}
            element={
              <ProtectedRoute>
                {child.component ? <child.component /> : <div>{child.label} Page</div>}
              </ProtectedRoute>
            }
          />
        ));
      }

      return (
        <Route
          key={route.key}
          path={route.path}
          element={
            <ProtectedRoute>
              {route.component ? <route.component /> : <div>{route.label} Page</div>}
            </ProtectedRoute>
          }
        />
      );
    });

  const isPublicOrAdmin = location.pathname.startsWith('/admin') || location.pathname.startsWith('/in-touch');

  return (
    <AdminAuthProvider>
      <Routes>
        {/* ========= NORMAL USER ROUTES ========= */}
        <Route
          path="/"
          element={
            isAuthenticated ? (
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            ) : (
              <Navigate to="/login" replace />
            )
          }
        >
          {renderRoutes(routes)}
        </Route>

        <Route
          path="/login"
          element={isAuthenticated ? <Navigate to="/" replace /> : <Login />}
        />

        {/* ========= ADMIN ROUTES ========= */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/*" element={<AdminRoutes />} />

        {/* ========= PUBLIC ROUTES ========= */}
        <Route path="/in-touch" element={<HomePage />}>
          <Route index element={<LandingPage />} />
          <Route path="*" element={<AppRoutes />} />
        </Route>

        {!isAuthenticated && !isPublicOrAdmin && (
          <Route path="*" element={<Navigate to="/login" replace />} />
        )}
      </Routes>


    </AdminAuthProvider>
  );
};

export default App;
